(function () {
  if (window.__bmCartDrawerPartialRefresh) return;
  window.__bmCartDrawerPartialRefresh = true;

  const SECTION_ID = 'cart-drawer'; // sections/cart-drawer.liquid

  function getDrawerScrollEl() {
    return document.querySelector('#CartDrawer .hdt-mini-cart__sroll');
  }

  function swapInnerHTML(current, next) {
    if (!current || !next) return;
    current.innerHTML = next.innerHTML;
  }

  function setAddedState(btn, opts = {}) {
    const { label = 'Added', ms = 1500 } = opts;
    if (!btn) return;

    // keep original label
    const originalText = btn.dataset.bmOriginalText || btn.textContent.trim();
    btn.dataset.bmOriginalText = originalText;

    btn.disabled = true;
    btn.classList.add('is-added');
    btn.textContent = label;

    window.setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
      btn.classList.remove('is-added');
    }, ms);
  }

  async function fetchCartDrawerHTML() {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    const url = `${root}?section_id=${SECTION_ID}`;
    const res = await fetch(url, { headers: { 'Accept': 'text/html' } });
    if (!res.ok) throw new Error('Failed to fetch cart drawer section HTML.');
    return res.text();
  }

  async function refreshDrawerParts() {
    const scrollEl = getDrawerScrollEl();
    const scrollTop = scrollEl ? scrollEl.scrollTop : 0;

    const html = await fetchCartDrawerHTML();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Only update the parts that should change
    const currentShipping = document.querySelector('#CartDrawer [data-cart-refresh="shipping"]');
    const currentItems    = document.querySelector('#CartDrawer [data-cart-refresh="items"]');
    const currentSummary  = document.querySelector('#CartDrawer [data-cart-refresh="summary"]');
    const currentBottomTotal = document.querySelector('#CartDrawer [data-cart-refresh="bottom-total"]');

    const nextShipping = doc.querySelector('[data-cart-refresh="shipping"]');
    const nextItems    = doc.querySelector('[data-cart-refresh="items"]');
    const nextSummary  = doc.querySelector('[data-cart-refresh="summary"]');
    const nextBottomTotal = doc.querySelector('[data-cart-refresh="bottom-total"]');

    // Replace content
    swapInnerHTML(currentShipping, nextShipping);
    swapInnerHTML(currentItems, nextItems);
    swapInnerHTML(currentSummary, nextSummary);

    // Bottom: update ONLY the total text to avoid breaking bottom layout
    if (currentBottomTotal && nextBottomTotal) {
      currentBottomTotal.innerHTML = nextBottomTotal.innerHTML;
    }

    // Restore scroll position (prevents jump)
    const newScrollEl = getDrawerScrollEl();
    if (newScrollEl) newScrollEl.scrollTop = scrollTop;

    // notify any theme listeners (harmless if unused)
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  async function addToCart(variantId, sellingPlanId) {
    const payload = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (sellingPlanId) payload.items[0].selling_plan = Number(sellingPlanId);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      let msg = 'Could not add item to cart.';
      try { msg = (await res.json()).description || msg; } catch (e) {}
      throw new Error(msg);
    }

    return res.json();
  }

  function hideAddedUpsellProduct(productId) {
    if (!productId) return;
    const el = document.querySelector(`#CartDrawer [data-upsell-product-id="${productId}"]`);
    if (!el) return;
    el.style.display = 'none';
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.bm-upsell-add, [data-upsell-add-selected]');
    if (!btn) return;

    e.preventDefault();
    if (btn.disabled) return;

    // Determine variant id
    let variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      const wrap = btn.closest('.bm-upsell-variant');
      const select = wrap && wrap.querySelector('[data-upsell-variant-select]');
      if (select) variantId = select.value;
    }

    const sellingPlanId = btn.getAttribute('data-selling-plan-id');

    if (!variantId) return;

    // Immediate feedback
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    try {
      const added = await addToCart(variantId, sellingPlanId);

      // show "Added" without a visible refresh
      setAddedState(btn, { label: 'Added', ms: 1500 });

      // Hide the upsell card immediately (optional UX)
      if (added && added.product_id) hideAddedUpsellProduct(String(added.product_id));

      // Update only key cart parts (keeps bottom styling stable)
      await refreshDrawerParts();
    } catch (err) {
      console.warn(err);
      alert(err.message || 'Could not add item.');
      btn.disabled = false;
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });
})();
